import { ofType } from "redux-observable";
import { EMPTY, from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IdOutskirtBuildings } from "../../../constants/IdOutskirtBuildings";
import { selectOutskirtBuildingInfo, selectOutskirtBuildingLevelFromInfo, } from "../../../selectors/selectOutskirtBuildingInfo";
import { actionOutskirtBuildingLoadNextLevelAssets, actionOutskirtsInfoUpdateStageInfo, } from "../../info/outskirts/actionOutskirtsInfo";
import { TypeActionContractInfo } from "../actionContractInfo";
export var epicContractInfoReceived = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionContractInfo.Received), switchMap(function (action) {
        var state = state$.value;
        var marketStage;
        var marketBuilding = selectOutskirtBuildingInfo(state, IdOutskirtBuildings.Market);
        var marketBuildingLevel = selectOutskirtBuildingLevelFromInfo(marketBuilding);
        var actions = [];
        if (action.contractInfo &&
            action.contractInfo.market &&
            action.contractInfo.market.stage) {
            var newMarketStage = action.contractInfo.market.stage;
            if (marketBuildingLevel !== newMarketStage) {
                actions.push(actionOutskirtBuildingLoadNextLevelAssets(marketBuilding));
            }
            marketStage = newMarketStage;
        }
        if (!marketStage) {
            return EMPTY;
        }
        var outskirtInfo = {
            stage: marketStage,
            typeId: IdOutskirtBuildings.Market,
        };
        actions.push(actionOutskirtsInfoUpdateStageInfo(outskirtInfo));
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractInfoReceived.ts
// module id = 1994
// module chunks = 3